import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cc from 'classcat';
import { formatCurrency } from 'lib/formatters';
import './winMessage.css';

class Winner extends Component {
  shouldComponentUpdate(nextProps) {
    return !(
      (this.props.jackpotAmount && !nextProps.jackpotAmount) ||
      (this.props.userMessage && !nextProps.userMessage) ||
      this.props === nextProps
    );
  }

  render() {
    const { jackpotAmount, jackpotTitle, userMessage, line, noTrophy } = this.props;
    const messageClasses = cc([
      'winMessageNew',
      line && 'winMessageNew--line',
      !line && 'winMessageNew--screenCenter'
    ]);
    const contentClasses = cc([
      'content',
      line && 'content--elevated',
      !line && 'content--backdrop'
    ]);
    const bingoLabelClasses = cc([
      'content__bingoLabel',
      noTrophy && !line && 'content__bingoLabel--small',
      line && 'content__bingoLabel--line'
    ]);
    const winTypeLabelClasses = cc([
      'content__winTypeLabel',
      noTrophy && !line && 'content__winTypeLabel--small',
      line && 'content__winTypeLabel--line '
    ]);
    const winAmountLabelClasses = cc([
      'content__winAmount',
      (noTrophy || line) && 'content__winAmount--small'
    ]);
    const winnersLabelClasses = cc([
      'content__winnersLabel',
      (noTrophy || line) && 'content__winnersLabel--notWinner'
    ]);

    return (
      <div className={messageClasses}>
        <div className={contentClasses}>
          {!noTrophy && !line && (
            <div className="content__Conffetti content__Conffetti--top">
              <img src="/assets/images1/games/confetti-top.svg" alt="" />
            </div>
          )}
          <h1 className={bingoLabelClasses}>Bingo!</h1>
          {!noTrophy && !line && (
            <img className="content__kachingSticker" src="/assets/images1/kaching-3.svg" alt="" />
          )}
          <span className={winTypeLabelClasses}>{jackpotTitle}</span>
          <p className={winnersLabelClasses}>{userMessage}</p>
          <div className={winAmountLabelClasses}>{formatCurrency(jackpotAmount)}</div>
          {!noTrophy && !line && (
            <div className="content__Conffetti content__Conffetti--bot">
              <img src="/assets/images1/games/confetti-bot.svg" alt="" />
            </div>
          )}
        </div>
      </div>
    );
  }
}

Winner.propTypes = {
  jackpotAmount: PropTypes.number,
  line: PropTypes.bool,
  noTrophy: PropTypes.bool,
  jackpotTitle: PropTypes.string,
  userMessage: PropTypes.string
};

Winner.defaultProps = {
  jackpotAmount: 0,
  noTrophy: false,
  line: false,
  jackpotTitle: 'Full house win!',
  userMessage: 'Someone has won'
};

export default Winner;
